import { useTranslation } from "react-i18next";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Divider, Flex } from "antd";
import { createStyles } from "antd-style";

import { Button } from "@av/components/atoms/Button";
import { Typography } from "@av/components/atoms/typography/Typography";
import { AvantiLogo } from "@av/components/molecules/logo/AvantiLogo";

const useStyles = createStyles(({ token, css }) => ({
  contentWrapper: css`
    width: 100%;
    max-width: 420px;
    padding: ${token.paddingMD}px;

    @media (max-width: ${token.screenMD}px) {
      max-width: 350px;
      padding: 0;
    }
  `,
}));

interface MagicLinkSuccessProps {
  email: string;
  expiresIn?: number;
  onBack: () => void;
}

export function MagicLinkSuccess({ email, expiresIn, onBack }: MagicLinkSuccessProps) {
  const { t } = useTranslation();
  const { styles } = useStyles();

  return (
    <Flex vertical align="center" justify="center" style={{ height: "100%", width: "100%" }}>
      <AvantiLogo testIdPrefix="magic-link-success" />
      <div className={styles.contentWrapper}>
        <Button testIdPrefix="back-link" type="link" style={{ padding: 0 }} onClick={onBack}>
          <ArrowLeftOutlined aria-hidden />
          {t("auth.login.magicLinkSent_back")}
        </Button>

        <Typography.Title testIdPrefix="magic-link-generation-success" level={3}>
          {t("auth.login.magicLinkSent_title")}
        </Typography.Title>

        <Typography.Paragraph
          testIdPrefix="magic-link-generation-success-explanation"
          type="secondary"
        >
          {expiresIn === undefined
            ? t("auth.login.magicLinkSent_descriptionWithoutExpiry", { email })
            : t("auth.login.magicLinkSent_description", {
                email,
                count: Math.ceil(expiresIn / 60_000),
              })}
        </Typography.Paragraph>

        <Divider />

        <Typography.Text
          type="secondary"
          testIdPrefix="magic-link-generation-success-didnt-recieve"
        >
          {t("auth.login.magicLinkSent_didntReceive")}{" "}
          <Typography.Link
            onClick={onBack}
            testIdPrefix="magic-link-generation-success-didnt-recieve"
          >
            {t("auth.login.magicLinkSent_tryAgain")}!
          </Typography.Link>
        </Typography.Text>
      </div>
    </Flex>
  );
}
